module.exports = __webpack_public_path__ + "static/media/countBathrooms.7956fa96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/countBathrooms.svg
// module id = 306
// module chunks = 0